import { createReducer } from '@reduxjs/toolkit';
import {
  INIT_USER_MONEY,
  SET_USER_MONEY,
  SET_USER_PRIVATE_MONEY_HIGHLIGHTED,
} from '../actions/user-private-money';
import { merchantApplicationEnabledOf } from '../authorities';
import type AdminUser from '../models/admin_user';
import { components } from '../schema/docs/api/admin';

export type UserPrivateMoneyState = {
  selectedMoney: UserPrivateMoney;
  availableMoneys: UserPrivateMoney[];
  isHighlighted: boolean;
  allowedMoneys: UserPrivateMoney[];
};
export type UserPrivateMoney = components['schemas']['PrivateMoney'];

const initialState: UserPrivateMoneyState = {
  selectedMoney: {} as UserPrivateMoney,
  availableMoneys: [],
  isHighlighted: false,
  allowedMoneys: [],
};

const userPrivateMoneyReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(INIT_USER_MONEY, (_, action) => ({ ...initialState, ...action.payload }))
    .addCase(SET_USER_MONEY, (state, action) => ({ ...state, selectedMoney: action.payload }))
    .addCase(SET_USER_PRIVATE_MONEY_HIGHLIGHTED, (state, action) => ({
      ...state,
      isHighlighted: action.payload.isHighlighted,
      allowedMoneys: action.payload.isHighlighted ? action.payload.allowedMoneys : [],
    }))
);

export const selectUserPrivateMoney = (state: { userPrivateMoney: UserPrivateMoneyState }) =>
  state.userPrivateMoney.selectedMoney;

// 選択中マネーの発行体組織が加盟店 申込→審査→承認 フローを利用するか。
// 発行体/加盟事業者いずれのログインでも、選択中マネー起点で管理画面の表示モードを判定する。
// 未設定・未取得の場合は false (=非表示) を既定とする。
// 判定ロジックはルートガード (authorities.js) と共通の merchantApplicationEnabledOf に集約。
// フラグは user (AdminUser) の display_features_by_organization を選択中マネーの
// organization.code で引いて解決する。
export const selectShowMerchantApplication = (state: {
  userPrivateMoney: UserPrivateMoneyState;
  user: AdminUser;
}): boolean => merchantApplicationEnabledOf(state.userPrivateMoney.selectedMoney, state.user);

export default userPrivateMoneyReducer;
